/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable valid-jsdoc */
/* eslint-disable jsdoc/require-param */
import { Series } from '../series/chart-series';
import { TechnicalAnalysis } from './indicator-base';
/**
 * `MacdIndicator` module is used to render MACD indicator.
 */
export class MacdIndicator extends TechnicalAnalysis {
    /**
     * Defines the collection of series to represent the MACD indicator
     *
     * @private
     */
    initSeriesCollection(indicator, chart) {
        super.initSeriesCollection(indicator, chart);
        if (indicator.macdType === 'Line' || indicator.macdType === 'Both') {
            const macdSeries = new Series(indicator, 'targetSeries', {}, true);
            this.setSeriesProperties(macdSeries, indicator, 'MacdLine', indicator.macdLine.color, indicator.macdLine.width, chart);
        }
        if (indicator.macdType === 'Histogram' || indicator.macdType === 'Both') {
            const histogramSeries = new Series(indicator, 'targetSeries', {}, true);
            histogramSeries.type = 'Column';
            this.setSeriesProperties(histogramSeries, indicator, 'Histogram', indicator.macdPositiveColor, indicator.width, chart);
        }
    }
    /**
     * Defines the predictions using MACD approach
     *
     * @private
     */
    initDataSource(indicator, chart) {
        let signalCollection = [];
        const fastPeriod = indicator.fastPeriod;
        const slowPeriod = indicator.slowPeriod;
        const trigger = indicator.period;
        const length = fastPeriod + trigger;
        let macdCollection = [];
        let histogramCollection = [];
        const validData = indicator.points;
        const signalSeries = indicator.targetSeries[0];
        let histogramSeries;
        let macdLineSeries;
        if (indicator.macdType === 'Histogram') {
            histogramSeries = indicator.targetSeries[1];
        }
        else {
            macdLineSeries = indicator.targetSeries[1];
            if (indicator.macdType === 'Both') {
                histogramSeries = indicator.targetSeries[2];
            }
        }
        if (validData && length < validData.length && slowPeriod <= fastPeriod &&
            slowPeriod > 0 && (length - 2) >= 0) {
            const shortEMA = this.calculateEMAValues(slowPeriod, validData, 'close');
            const longEMA = this.calculateEMAValues(fastPeriod, validData, 'close');
            const macdValues = this.getMACDVales(indicator, shortEMA, longEMA);
            macdCollection = this.getMACDPoints(indicator, macdValues, validData, macdLineSeries || signalSeries);
            const signalEMA = this.calculateEMAValues(trigger, macdCollection, 'y');
            signalCollection = this.getSignalPoints(indicator, signalEMA, validData, signalSeries);
            if (histogramSeries) {
                histogramCollection = this.getHistogramPoints(indicator, macdValues, signalEMA, validData, histogramSeries);
            }
        }
        this.setSeriesRange(signalCollection, indicator, indicator.targetSeries[0]);
        if (histogramSeries) {
            this.setSeriesRange(histogramCollection, indicator, histogramSeries);
        }
        if (macdLineSeries) {
            this.setSeriesRange(macdCollection, indicator, macdLineSeries);
        }
    }
    /**
     * Calculates the EMA values for the given period
     */
    calculateEMAValues(period, validData, field) {
        let sum = 0;
        let initialEMA = 0;
        const emaValues = [];
        const emaPercent = (2 / (period + 1));
        for (let i = 0; i < period; i++) {
            sum += Number(validData[i][field]);
        }
        initialEMA = (sum / period);
        emaValues.push(initialEMA);
        let emaAvg = initialEMA;
        for (let j = period; j < validData.length; j++) {
            emaAvg = (Number(validData[j][field]) - emaAvg) * emaPercent + emaAvg;
            emaValues.push(emaAvg);
        }
        return emaValues;
    }
    /**
     * Defines the MACD Points
     */
    getMACDPoints(indicator, macdPoints, validData, series) {
        const macdCollection = [];
        let dataMACDIndex = indicator.fastPeriod - 1;
        let macdIndex = 0;
        while (dataMACDIndex < validData.length) {
            macdCollection.push(this.getDataPoint(validData[dataMACDIndex].x, macdPoints[macdIndex], validData[dataMACDIndex], series, macdCollection.length));
            dataMACDIndex++;
            macdIndex++;
        }
        return macdCollection;
    }
    /**
     * Calculates the signal points
     */
    getSignalPoints(indicator, signalEma, validData, series) {
        let dataSignalIndex = indicator.fastPeriod + indicator.period - 2;
        let signalIndex = 0;
        const signalCollection = [];
        while (dataSignalIndex < validData.length) {
            signalCollection.push(this.getDataPoint(validData[dataSignalIndex].x, signalEma[signalIndex], validData[dataSignalIndex], series, signalCollection.length));
            dataSignalIndex++;
            signalIndex++;
        }
        return signalCollection;
    }
    /**
     * Calculates the MACD values
     */
    getMACDVales(indicator, shortEma, longEma) {
        const macdPoints = [];
        const diff = indicator.fastPeriod - indicator.slowPeriod;
        for (let i = 0; i < longEma.length; i++) {
            macdPoints.push((shortEma[i + diff] - longEma[i]));
        }
        return macdPoints;
    }
    /**
     * Calculates the Histogram Points
     */
    getHistogramPoints(indicator, macdPoints, signalEma, validData, series) {
        let dataHistogramIndex = indicator.fastPeriod + indicator.period - 2;
        let histogramIndex = 0;
        const histogramCollection = [];
        while (dataHistogramIndex < validData.length) {
            histogramCollection.push(this.getDataPoint(validData[dataHistogramIndex].x, macdPoints[histogramIndex + (indicator.period - 1)] -
                signalEma[histogramIndex], validData[dataHistogramIndex], series, histogramCollection.length, indicator));
            dataHistogramIndex++;
            histogramIndex++;
        }
        return histogramCollection;
    }
    /**
     * To destroy the MACD Indicator.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the MACD indicator
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'MacdIndicator';
    }
}
